import styled from 'styled-components';
import { MainColor, SubColor } from '../style/styleValue';

const Encouragement = () => {
  return (
    <PageWrapper>
      <Container>
        <Badge>격려의 글</Badge>
        <PaperCard>
          <AccentLine />
          <Title>소아암·희귀질환 병리 아틀라스 구축 사업에 부쳐</Title>
          
          <Content>
            <Paragraph>
              소아암과 희귀질환은 그 희소성으로 인해 정확한 진단과 치료 방향 설정에 많은 어려움이 있어 왔습니다. 특히 병리학적 진단은 치료의 시작점이자 예후 예측의 핵심 요소임에도 불구하고, 증례의 부족과 표준화된 참고 자료의 제한으로 인해 전문가들조차 진단에 고심하는 경우가 적지 않습니다.
            </Paragraph>
            <Paragraph>
              이러한 상황에서 소아암·희귀질환지원사업단의 병리 아틀라스 구축 사업은 매우 시의적절하고 의미 있는 프로젝트입니다. 본 사업을 통해 구축되는 포괄적이고 체계적인 병리 이미지 데이터베이스는 단순한 자료 집합을 넘어, 정확한 진단을 위한 실질적 가이드이자 교육 자료로서 큰 가치를 지닐 것입니다.
            </Paragraph>
            <Paragraph>
              특히 디지털 병리학의 발전과 함께 고해상도 이미지, 면역조직화학 염색, 분자병리학적 정보가 통합된 아틀라스는 전국의 병리 전문의들이 희귀 증례를 접했을 때 신속하고 정확한 진단을 내리는 데 실질적인 도움을 줄 것으로 기대됩니다. 또한 차세대 병리 전문의 양성을 위한 교육 자원으로도 활용될 수 있어, 그 파급 효과는 현재를 넘어 미래까지 이어질 것입니다.
            </Paragraph>
            <Paragraph>
              소아병리연구회는 국내 소아 병리 분야의 발전과 전문가 네트워크 구축을 위해 노력해 온 학술단체로서, 본 아틀라스 구축 사업이 임상 현장에서 실질적으로 활용되고 지속적으로 발전할 수 있도록 적극 협력하고자 합니다.
            </Paragraph>
            <Paragraph>
              본 사업의 성공적인 완수와 소아암·희귀질환으로 고통받는 환아들에게 보다 정확한 진단과 최적의 치료가 제공될 수 있기를 진심으로 기원합니다.
            </Paragraph>
          </Content>

          <SignOffSection>
            <DateText>2026년 1월</DateText>
            <AuthorInfo>
              <Affiliation>대한병리학회 소아병리연구회 대표</Affiliation>
              <Affiliation>성균관의대 삼성서울병원 병리과 교수</Affiliation>
              <AuthorName>김 정 선</AuthorName>
            </AuthorInfo>
          </SignOffSection>
        </PaperCard>
      </Container>
    </PageWrapper>
  );
};

const PageWrapper = styled.div`
  background-color: #f8f9fc;
  min-height: calc(100vh - 100px);
  padding: 60px 20px;
  display: flex;
  justify-content: center;
`;

const Container = styled.div`
  width: 100%;
  max-width: 860px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Badge = styled.span`
  background-color: ${SubColor};
  color: white;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 24px;
  letter-spacing: 0.5px;
`;

const PaperCard = styled.div`
  background: #ffffff;
  width: 100%;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
  padding: 60px 80px;
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 40px 30px;
  }
`;

const AccentLine = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: ${`linear-gradient(90deg, ${MainColor}, ${SubColor})`};
`;

const Title = styled.h1`
  font-size: 28px;
  font-weight: 700;
  color: #1a202c;
  text-align: center;
  margin-bottom: 50px;
  word-break: keep-all;
  line-height: 1.4;

  @media (max-width: 768px) {
    font-size: 24px;
    margin-bottom: 40px;
  }
`;

const Content = styled.div`
  margin-bottom: 60px;
`;

const Paragraph = styled.p`
  font-size: 16px;
  line-height: 1.8;
  color: #4a5568;
  margin-bottom: 24px;
  word-break: keep-all;
  text-align: justify;

  &:last-child {
    margin-bottom: 0;
  }
`;

const SignOffSection = styled.div`
  border-top: 1px solid #edf2f7;
  padding-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
`;

const DateText = styled.div`
  font-size: 16px;
  color: #718096;
  margin-bottom: 20px;
  letter-spacing: 0.5px;
`;

const AuthorInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const Affiliation = styled.span`
  font-size: 15px;
  color: #4a5568;
`;

const AuthorName = styled.span`
  font-size: 22px;
  font-weight: 700;
  color: #1a202c;
  margin-top: 12px;
  letter-spacing: 2px;
`;

export default Encouragement;